document.addEventListener('DOMContentLoaded', () => {

    var $ManualPages = $('div#download-page');
    var $ManualGrids = $ManualPages.find('> .grid');

    function getDownloadPageProducts() {
        return $ManualPages.not('.download-page--merged-hidden').find('.manual-product');
    }

    function mergeManualProductGrids() {
        if ($ManualGrids.length <= 1) return;

        var $PrimaryGrid = $ManualGrids.first();
        $ManualGrids.slice(1).each(function () {
            var $Grid = $(this);
            $Grid.children('.shopify-block').appendTo($PrimaryGrid);
            $Grid.closest('div#download-page').addClass('download-page--merged-hidden');
        });
    }

    mergeManualProductGrids();

    var $SearchInput = $('#dowload_search input');
    var $NotSearch = $('.not-search');

    function syncDownloadManualsTiles() {
        var type = $('#se-pro-type').val();
        $('.download-manuals-nav__tile').each(function () {
            var $t = $(this);
            var active = Boolean(type) && $t.attr('data-filter-value') === type;
            $t.toggleClass('is-active', active);
            $t.attr('aria-pressed', active ? 'true' : 'false');
        });
    }

    function clearDownloadManualsTilesActive() {
        $('.download-manuals-nav__tile').removeClass('is-active').attr('aria-pressed', 'false');
    }

    function showAllManualProducts() {
        getDownloadPageProducts().parents('.shopify-block').show();
    }

    function clearSearchAndShowAll() {
        showAllManualProducts();
        clearDownloadManualsTilesActive();
        $('#se-pro-type').val('');
        $NotSearch.hide();
    }

    function applyTypeFilter() {
        var type = $('#se-pro-type').val();
        var $pageProducts = getDownloadPageProducts();

        if (!type || type === 'ALL') {
            $pageProducts.parents('.shopify-block').show();
            return;
        }

        $pageProducts.each(function () {
            var $this = $(this);
            var value = $this.attr('value');
            var $parent = $this.parents('.shopify-block');

            if (type === value) {
                $parent.show();
            } else {
                $parent.hide();
            }
        });
    }

    // type 选择功能
    $('#se-pro-type').change(function () {
        if (($SearchInput.val() || '').trim()) {
            manualpageSearch();
        } else {
            applyTypeFilter();
            syncDownloadManualsTiles();
        }
        SearchText();
    });

    var downloadNavDragState = { moved: false, startX: 0 };

    function initDownloadManualsNavScroll() {
        var mobileMq = window.matchMedia('(max-width: 749px)');
        var grids = document.querySelectorAll('.download-manuals-nav__grid');
        if (!grids.length) return;

        function updateScrollThumb(grid) {
            var categories = grid.closest('.download-manuals-nav__categories');
            if (!categories) return;
            var thumb = categories.querySelector('.download-manuals-nav__scroll-thumb');
            var track = categories.querySelector('.download-manuals-nav__scroll-track');
            var progressbar = categories.querySelector('.download-manuals-nav__scroll-bar');
            if (!thumb || !track) return;

            var trackWidth = track.clientWidth;
            var scrollWidth = grid.scrollWidth - grid.clientWidth;
            var isMobile = mobileMq.matches;
            var percent = scrollWidth > 0 ? Math.round((grid.scrollLeft / scrollWidth) * 100) : 0;

            if (progressbar) {
                progressbar.setAttribute('aria-valuenow', String(percent));
                if (isMobile) {
                    progressbar.setAttribute('aria-hidden', 'false');
                    if (progressbar.id) {
                        grid.setAttribute('aria-describedby', progressbar.id);
                    }
                } else {
                    progressbar.setAttribute('aria-hidden', 'true');
                    grid.removeAttribute('aria-describedby');
                }
            }

            if (!isMobile) {
                thumb.style.width = '0';
                thumb.style.transform = 'translateX(0)';
                return;
            }

            if (scrollWidth <= 0) {
                var idleThumbWidth = Math.min(100, trackWidth);
                thumb.style.width = idleThumbWidth + 'px';
                thumb.style.transform = 'translateX(0)';
                return;
            }

            var thumbWidth = Math.max((trackWidth * grid.clientWidth) / grid.scrollWidth, 48);
            var maxOffset = trackWidth - thumbWidth;
            var offset = (maxOffset * grid.scrollLeft) / scrollWidth;

            thumb.style.width = thumbWidth + 'px';
            thumb.style.transform = 'translateX(' + offset + 'px)';
        }

        grids.forEach(function (grid) {
            var isDragging = false;
            var startX = 0;
            var startScrollLeft = 0;

            function endDrag(e) {
                if (!isDragging) return;
                isDragging = false;
                grid.classList.remove('is-dragging');
                if (e && grid.hasPointerCapture(e.pointerId)) {
                    grid.releasePointerCapture(e.pointerId);
                }
                updateScrollThumb(grid);
            }

            grid.addEventListener('scroll', function () {
                updateScrollThumb(grid);
            }, { passive: true });

            grid.addEventListener('keydown', function (e) {
                if (!mobileMq.matches) return;
                var scrollWidth = grid.scrollWidth - grid.clientWidth;
                if (scrollWidth <= 0) return;
                var step = Math.max(grid.clientWidth * 0.4, 80);
                if (e.key === 'ArrowRight') {
                    e.preventDefault();
                    grid.scrollLeft = Math.min(grid.scrollLeft + step, scrollWidth);
                } else if (e.key === 'ArrowLeft') {
                    e.preventDefault();
                    grid.scrollLeft = Math.max(grid.scrollLeft - step, 0);
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    grid.scrollLeft = 0;
                } else if (e.key === 'End') {
                    e.preventDefault();
                    grid.scrollLeft = scrollWidth;
                }
            });

            grid.addEventListener('pointerdown', function (e) {
                if (!mobileMq.matches) return;
                if (e.pointerType === 'mouse' && e.button !== 0) return;

                isDragging = true;
                downloadNavDragState.moved = false;
                downloadNavDragState.startX = e.clientX;
                startX = e.clientX;
                startScrollLeft = grid.scrollLeft;
                grid.classList.add('is-dragging');
                grid.setPointerCapture(e.pointerId);
            });

            grid.addEventListener('pointermove', function (e) {
                if (!isDragging) return;
                var dx = e.clientX - startX;
                if (Math.abs(dx) > 6) {
                    downloadNavDragState.moved = true;
                }
                grid.scrollLeft = startScrollLeft - dx;
            });

            grid.addEventListener('pointerup', endDrag);
            grid.addEventListener('pointercancel', endDrag);

            requestAnimationFrame(function () {
                updateScrollThumb(grid);
            });
        });

        window.addEventListener('resize', function () {
            grids.forEach(updateScrollThumb);
        });

        window.addEventListener('load', function () {
            grids.forEach(updateScrollThumb);
        });

        if (typeof mobileMq.addEventListener === 'function') {
            mobileMq.addEventListener('change', function () {
                grids.forEach(updateScrollThumb);
            });
        }
    }

    initDownloadManualsNavScroll();

    $(document).on('click', '.download-manuals-nav__tile', function (e) {
        if (downloadNavDragState.moved) {
            downloadNavDragState.moved = false;
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
        }
        var v = $(this).attr('data-filter-value');
        if (v === undefined) return;
        $('#se-pro-type').val(v).trigger('change');
    });

    $(document).on('click', '.download-main__cta, .download-main__close', function (e) {
        e.stopPropagation();
    });


    function manualpageSearch() {
        var query = ($SearchInput.val() || '').trim().toLowerCase();
        var $pageProducts = getDownloadPageProducts();

        if (!query) {
            clearSearchAndShowAll();
            return;
        }

        clearDownloadManualsTilesActive();

        $pageProducts.each(function () {
            var $this = $(this);
            var $parent = $this.parents('.shopify-block');
            var title = $this.find('.grid-view-item__title').text().toLowerCase();

            if (title.includes(query)) {
                $parent.show();
            } else {
                $parent.hide();
            }
        });
    }

    function SearchText() {
        var allHidden = true;
        getDownloadPageProducts().each(function () {
            var $block = $(this).parents('.shopify-block');
            if ($block.css('display') !== 'none') {
                allHidden = false;
                return false;
            }
        });

        if (allHidden) {
            $NotSearch.show();
        } else {
            $NotSearch.hide();
        }
    }

    $SearchInput.on('input', function () {
        if (!($(this).val() || '').trim()) {
            clearSearchAndShowAll();
        }
    });

    $('#searchstr').keypress(function (e) {
        if (e.which == 13) {
            manualpageSearch();
            SearchText();
        }
    });

    $('.bt_manual').click(function () {
        manualpageSearch();
        SearchText();
    });



    function closeDownloadDialog($item) {
        var $active = $item && $item.length ? $item : $('#download-page .grid-view-item.active');
        $active.removeClass('active');
        $active.find('.download-dialog').attr('aria-hidden', 'true');
    }

    function openDownloadDialog($item) {
        closeDownloadDialog($('#download-page .grid-view-item.active').not($item));
        $item.addClass('active');
        $item.find('.download-dialog').attr('aria-hidden', 'false');
    }

    $('#download-page .grid-view-item').click(function (e) {
        if ($(e.target).closest('.download-main__cta, .download-main__close').length) return;
        if (window.matchMedia('(min-width: 750px)').matches) return;
        openDownloadDialog($(this));
    });

    $(document).on('click', '#download-page .download-dialog', function (e) {
        if (window.matchMedia('(min-width: 750px)').matches) return;
        if ($(e.target).closest('.download-main').length) return;
        e.stopPropagation();
        closeDownloadDialog($(this).closest('.grid-view-item'));
    });

    $(document).on('click', '#download-page .download-main .close_btn', function (e) {
        e.stopPropagation();
        closeDownloadDialog($(this).closest('.grid-view-item'));
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && window.matchMedia('(max-width: 749px)').matches) {
            closeDownloadDialog();
        }
    });
});